import {Theme} from "@mui/material";

const styles = (theme: Theme) => ({
    root: {
        minHeight: '50vh',
        backgroundColor: theme.palette.background.default,
    },
    paperForm: {
        padding: theme.spacing(5),
        backgroundColor: theme.palette.background.default,
    },
    alert: {
        marginBottom: theme.spacing(2),
    }
});

export default styles;
